import React from 'react';

import Link from '@swf/components/Link/Link';
import type { EventView, MarketView } from '@swf/generated/types/api/sports';
import { Icon } from '@swf/sports/components';
import SportsFormattedTimeZone from '@swf/sports/components/SportsFormattedTimeZone/SportsFormattedTimeZone';
import { getEventTypeIcon } from '@swf/sports/utils/getEventTypeIcon';

import styles from './OddsBoostEventLink.scss';

interface Props {
  competitionSlug: string | undefined;
  eventTypeSlug: string;
  market: MarketView;
  event: EventView;
  shouldShowOddsBoostLogo?: true;
}

export const OddsBoostEventLink: React.FC<Props> = ({
  competitionSlug,
  market,
  event,
  eventTypeSlug,
  shouldShowOddsBoostLogo
}) => {
  const { eventId, eventSlug, eventName, eventStartTime, eventTypeId } = event;

  const icon = getEventTypeIcon(eventTypeId);

  const content = (
    <span className={styles.linkWrapper}>
      {shouldShowOddsBoostLogo ? (
        <Icon name="price-boost" size="sm" className={styles.oddsBoostIcon} />
      ) : null}
      <Icon name={icon} size="xl" className={styles.sportIcon} />
      <span className={styles.linkText}>
        {eventName}
        {market.marketLevels[0] === 'AVB_EVENT' && (
          <>
            {' '}
            &middot; <SportsFormattedTimeZone date={eventStartTime} format="medium" withTime />
          </>
        )}
      </span>
      <Icon name="chevron-medium-right" className={styles.linkIcon} size="xl" />
    </span>
  );

  return competitionSlug ? (
    <Link
      className={styles.link}
      alias={market.marketLevels[0] === 'AVB_EVENT' ? 'sportsEvent' : 'sportsCompetitionOutrights'}
      values={{
        competitionId: market.competitionId,
        competitionSlug,
        eventId,
        eventSlug,
        eventTypeId,
        eventTypeSlug
      }}
    >
      {content}
    </Link>
  ) : (
    content
  );
};
